<ac-checkbox *ngIf="hasDefaultObject && !isEdit" [(acModel)]="useDefaultHTTPSettings"
             [labelText]="useDefaultSettingsCheckboxTitle"
             (acModelChange)="useDefaultHTTPSettings = $event; useDefaultHTTPSettingsChanged()">
</ac-checkbox>

<ac-checkbox *ngIf="hasEditHttpCheckbox && isEdit" labelText="Edit HTTP Settings" [(acModel)]="editHttpSettings"
             (acModelChange)="editHttpSettings = $event; useDefaultHTTPSettingsChanged()">
</ac-checkbox>

<ng-container *ngIf="((!isEdit && useDefaultHTTPSettings) || (isEdit && !editHttpSettings) ? originalHTTPObject : httpObject) as http">
    <ac-input-container label="Device Admin User">
        <ac-textfield (acModelChange)="http.gatewayUser = $event"
                      [acModel]="http.gatewayUser"
                      [attr.alternativeName]="httpObjectName + '.gatewayUser'"
                      [ngDisabled]="(!isEdit && useDefaultHTTPSettings) || (isEdit && !editHttpSettings)">
        </ac-textfield>
    </ac-input-container>

    <ac-input-container editModePrefix="Change" label="Device Admin Password">
        <ac-password [acModel]="http.gatewayPassword"
                     (acModelChange)="httpObject.gatewayPassword = $event"
                     [attr.alternativeName]="httpObjectName + '.gatewayPassword'"
                     [ngDisabled]="(!isEdit  && useDefaultHTTPSettings) || (isEdit && !editHttpSettings)">
        </ac-password>
    </ac-input-container>

    <ac-input-container label="Communication Protocol">
        <ac-single-select [acModel]="http.httpsConnection"
                   (acModelChange)="http.httpsConnection = $event; httpsConnectionChanged()"
                   [attr.alternativeName]="httpObjectName + '.httpsConnection'"
                   [items]="httpConnectionItems"
                   [ngDisabled]="(!isEdit  && useDefaultHTTPSettings) || (isEdit && !editHttpSettings)">
        </ac-single-select>
    </ac-input-container>

    <ac-checkbox *ngIf="http.verifyCertificate !== undefined && http.httpsConnection === 'ENABLED'"
                 labelText="Verify Certificate"
                 [acModel]="http.verifyCertificate"
                 (acModelChange)="http.verifyCertificate = $event"
                 [ngDisabled]="(!isEdit  && useDefaultHTTPSettings) || (isEdit && !editHttpSettings)">
    </ac-checkbox>
</ng-container>




